import { createSlice } from '@reduxjs/toolkit'
const img1 = "/assets/images/education/passport.jpg";

const educationSlice = createSlice({
    name: 'education',
    initialState: {
      payload: [
        {
          img: img1,
          cert: 'HIGHER NATIONAL DIPLOMA (HND)',
          school: 'UXTECH',
        },
        {
            img: img1,
            cert: 'HIGHER NATIONAL DIPLOMA (HND)',
            school: 'UXTECH',
          },
        
          
      ]
    }
    ,
    reducers: {
        education: (state, action) => {
            state.education = action.payload;
        }
    }
})

export const {education} = educationSlice.actions;
export default educationSlice.reducer;
